export default {"src":"/_next/static/media/teams.872e86b8.svg","height":29,"width":31,"blurWidth":0,"blurHeight":0};